module.exports = __webpack_public_path__ + "img/a.e370c0b4.png";